import React, { useEffect, useState } from "react";

import SuspenseLoader from "../../utils/SuspenceLoader";

const MenuCreate = React.lazy(() => import('./MenuCreate'));
const MenuEdit = React.lazy(() => import('./MenuEdit'));
const CustomerCreate = React.lazy(() => import('./CustomerCreate'));
const CustomerEdit = React.lazy(() => import('./CustomerEdit'));
const OrderCreate = React.lazy(() => import('./OrderCreate'));
const OrderEdit = React.lazy(() => import('./OrderEdit'));
const AccountCreate = React.lazy(() => import('./AccountCreate'));
const AccountEdit = React.lazy(() => import('./AccountEdit'));

const modals = {
    menuCreate: MenuCreate,
    "menuEdit/:menuId": MenuEdit,
    customerCreate: CustomerCreate,
    "customerEdit/:customerId": CustomerEdit,
    orderCreate: OrderCreate,
    "orderEdit/:orderId": OrderEdit,
    accountCreate: AccountCreate,
    "accountEdit/:accountId": AccountEdit,
};

function findModal(name) {
    const keys = Object.keys(modals);
    const nameParts = name.split('/');
    let foundModal = null;
    keys.forEach((key) => {
        const keyParts = key.split('/');
        if (keyParts[0] === nameParts[0] && keyParts.length === nameParts.length) {
            foundModal = modals[key];
        }
    });

    return foundModal;
}

function Modals() {
    const [currentModalName, setCurrentModalName] = useState(null);

    useEffect(() => {
        const handleChange = () => {
            const possibleHash = window.location.hash.replace('#', '');
            const modal = findModal(possibleHash);
            if (modal) {
                setCurrentModalName(possibleHash);
            } else {
                setCurrentModalName(null);
            }
        };
        handleChange();
        window.addEventListener('hashchange', handleChange);
        return () => window.removeEventListener('hashchange', handleChange);
    }, []);

    if (!currentModalName) {
        return null;
    }

    const Modal = findModal(currentModalName);
    return <SuspenseLoader><Modal /></SuspenseLoader>;
}

export default Modals;
export const setHash = (newHash) => {
    const modal = findModal(newHash);
    if (modal) {
        window.location.hash = newHash;
    }
};

window.setHash = setHash;